import ICONS from 'components/Icons';
import React from 'react';
import { AwardData, AwardType } from 'scenes/common/components/Awards';
import { HomeFlowType, HomeStepType } from 'scenes/home/types';
import { MotorFlowType, MotorStepType } from 'scenes/motor/types';

export const motorAwardDefinitions: AwardData = {
  [AwardType.canstar202122]: {
    logo: ICONS.LOGO.CANSTAR_2021_22,
    content: "Canstar's 2021 & 2022 Awards for Outstanding Value",
    // Flows to display award
    flowsToDisplay: [
      MotorFlowType.QuoteDetails,
      MotorFlowType.CoverOptions,
      MotorFlowType.AddDriver,
    ],
    // List any steps within flowsToDisplay where award
    // should not be displayed
    stepsToIgnore: [
      MotorStepType.FlybuysNumber,
      MotorStepType.Excess,
      MotorStepType.MarketAgreedValue,
      MotorStepType.OptionalExtras,
    ],
    disclaimerSymbol: '*',
    disclaimer: (
      <>
        The &nbsp;
        <a
          href="https://www.canstar.com.au/star-rating-reports/car-insurance/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Canstar
        </a>
        &nbsp; 5-Star Ratings for Outstanding Value Car insurance in Australia
        was awarded in June 2021 and June 2022.
      </>
    ),
  },
};

export const homeAwardDefinitions: AwardData = {
  [AwardType.financialAwards2021]: {
    logo: ICONS.LOGO.FINANCIAL_AWARDS_2021,
    content: "Voted Australia's Best Home Insurance in Queensland for 2021.",
    // Flows to display award
    flowsToDisplay: [HomeFlowType.QuoteDetails, HomeFlowType.CoverOptions],
    // List any steps within flowsToDisplay where award
    // should not be displayed
    stepsToIgnore: [
      HomeStepType.FlybuysNumber,
      HomeStepType.ContentsExcess,
      HomeStepType.BuildingExcess,
      HomeStepType.OptionalExtras,
      HomeStepType.SpecifiedContentsAnswer,
      HomeStepType.SpecifiedContentList,
      HomeStepType.AddSpecifiedContent,
      HomeStepType.UnspecifiedPortableContents,
    ],
    disclaimerSymbol: '^',
    disclaimer: (
      <>
        Awards are based on information collected from the DBM Atlas research
        program – feedback from over 80,000 businesses and/or retail customers
        January 2020 through December 2020. For DBM Atlas and DBM Australian
        Financial Awards information, visit &nbsp;
        <a
          href="https://www.dbmconsultants.com.au/"
          target="_blank"
          rel="noopener noreferrer"
        >
          DBM Consultants
        </a>
        .
      </>
    ),
  },
};
